import React from 'react';

const ProfessionalsToolbox = () => {
    return (
        <div>
            <h1>ProfessionalsToolbox page</h1>
        </div>
    );
}

export default ProfessionalsToolbox;
